/*
2018-11-07
 */
let clickName = null
const clearClick = () => {
  window.setTimeout(function () {
    clickName = null
  }, 1000)
}
// 注册事件监听
export const connectWebViewJavascriptBridge = (callback) => {
  // Android
  if (window.WebViewJavascriptBridge) {
    callback(window.WebViewJavascriptBridge)
  } else {
    document.addEventListener(
      'WebViewJavascriptBridgeReady',
      function () {
        callback(window.WebViewJavascriptBridge)
      },
      false
    )
  }
  // iOS
  if (window.WebViewJavascriptBridge) {
    return callback(window.WebViewJavascriptBridge)
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback)
  }
  window.WVJBCallbacks = [callback]
  var WVJBIframe = document.createElement('iframe')
  WVJBIframe.style.display = 'none'
  WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__'
  document.documentElement.appendChild(WVJBIframe)
  setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe)
  }, 0)
}
/* 调用原生方法 */
export const callNativeApp = (Name, Value, Title, count, type, promtion, dict) => {
  if (clickName === Name) {
    return
  }
  connectWebViewJavascriptBridge(function (bridge) {
    let data = {
      'name': Name,
      'value': Value,
      'title': Title,
      'count': count,
      'type': type,
      'promtion': promtion,
      'dict': dict
    }
    clickName = Name
    clearClick()
    // 调用原生方法
    bridge.callHandler('registerHDBridgeHandler', data, function (response) {})
  })
}
// 示例 箭头原生调用
// connectWebViewJavascriptBridge(function (bridge) {
//   // 注册一个 JavaScript Handler，native 调用时执行 H5 操作
//   bridge.registerHandler('callHDBridgeHandler', function (data, responseCallback) {
//     alert(`data2:${data}`)
//     // 接收来自 native 的数据 message
//     console.log(data)
//     // 返回数据给 Native
//     // let res = 'Response Data'
//     // responseCallback(res)
//   })
//
//   // Android初始化，必须
//   bridge.init(function (message, responseCallback) {
//     // 接收来自 native 的数据 message
//     console.log(message)
//     // 返回数据给 Native
//     let res = 'Response Data'
//     responseCallback(res)
//   })
// })



// WEBPACK FOOTER //
// ./src/utils/OverallJsMobile.js